import { httpClient } from "src/shared/services/httpClient";
import { MRT_PaginationState, MRT_SortingState } from "material-react-table";
import { format } from "date-fns";
import { AxiosResponse } from "axios";
import { SampleCompanyCaseDetailsView } from "src/sampleInspection/features/types";

export const getSampleInspection = (
  filters: any,
  pagination: MRT_PaginationState,
  sorting: MRT_SortingState,
) => {
  const params: Record<string, any> = {
    ...filters,
    length: pagination.pageSize,
    start: pagination.pageIndex * pagination.pageSize,
    sortingData: JSON.stringify(sorting),
    startDateFrom: filters.startDateFrom
      ? format(filters.startDateFrom, "yyyy-MM-dd")
      : undefined,
    startDateTo: filters.startDateTo
      ? format(filters.startDateTo, "yyyy-MM-dd")
      : undefined,
    expiryDateFrom: filters.expiryDateFrom
      ? format(filters.expiryDateFrom, "yyyy-MM-dd")
      : undefined,
    expiryDateTo: filters.expiryDateTo
      ? format(filters.expiryDateTo, "yyyy-MM-dd")
      : undefined,
    id: filters.id,
    statusId: filters.statusId,
    initiatorId: filters.initiatorId,
  };

  const formData = new FormData();
  for (let key in params) {
    if (params[key] !== undefined) {
      formData.append(key, params[key]);
    }
  }

  return httpClient.post("sampleInspection/samplesList", formData);
};

export const getSampleInspectionChamberAdmin = (
  filters: any,
  pagination: MRT_PaginationState,
  sorting: MRT_SortingState,
) => {
  const params: Record<string, any> = {
    ...filters,
    length: pagination.pageSize,
    start: pagination.pageIndex * pagination.pageSize,
    sortingData: JSON.stringify(sorting),
  };
  const formData = new FormData();
  for (let key in params) {
    const value = params[key];

    if (value !== undefined && value !== null) {
      if (value instanceof Date) {
        formData.append(key, format(value, "yyyy-MM-dd"));
      } else {
        formData.append(key, value);
      }
    }
  }

  return httpClient.post("/sampleInspection/organizationSamplesList", formData);
};

export const getAssignedInspectionsChamberUser = (
  filters: any,
  pagination: MRT_PaginationState,
  sorting: MRT_SortingState,
) => {
  const params: Record<string, any> = {
    ...filters,
    length: pagination.pageSize,
    start: pagination.pageIndex * pagination.pageSize,
    sortingData: JSON.stringify(sorting),
  };
  const formData = new FormData();
  for (let key in params) {
    if (params[key] !== undefined) {
      formData.append(key, params[key]);
    }
  }
  return httpClient.post(
    "/sampleInspection/chamberUserSampleCasesList",
    formData,
  );
};

export const getSupervisorySampleList = (
  filters: any,
  pagination: MRT_PaginationState,
  sorting: MRT_SortingState,
) => {
  const params: Record<string, any> = {
    length: pagination.pageSize,
    start: pagination.pageIndex * pagination.pageSize,
    sortingData: JSON.stringify(sorting),
    id: filters.id,
    status: filters.status,
    startDateFrom: filters.startDateFrom
      ? format(filters.startDateFrom, "yyyy-MM-dd")
      : undefined,
    startDateTo: filters.startDateTo
      ? format(filters.startDateTo, "yyyy-MM-dd")
      : undefined,
    expiryDateFrom: filters.expiryDateFrom
      ? format(filters.expiryDateFrom, "yyyy-MM-dd")
      : undefined,
    expiryDateTo: filters.expiryDateTo
      ? format(filters.expiryDateTo, "yyyy-MM-dd")
      : undefined,
  };

  const formData = new FormData();
  for (let key in params) {
    if (params[key] !== undefined) {
      formData.append(key, params[key]);
    }
  }

  return httpClient.post("supervisoryTeam/getSupervisorySampleList", formData);
};

export const getSampleInspectionFilters = () => {
  return httpClient.get("sampleInspection/sampleFilters");
};

export const getSupervisorySampleFilters = () =>
  httpClient.get("supervisoryTeam/getSupervisorySampleFilters");

export const createNewSampleInspection = (fields: {
  companySize: string[];
  companyStatus: number[];
  expiryDate: Date;
  corporateStatus: number[];
  chamberOrg: number[];
  percent: number;
  title: string[];
  violationType: number;
  description: string;
}) => {
  const payload = {
    title: fields.title,
    description: fields.description,
    expiryDate: format(fields.expiryDate, "yyyy-MM-dd"),
    filters: {
      companySize: fields.companySize,
      companyStatus: fields.companyStatus,
      corporateStatus: fields.corporateStatus,
      chamberOrg: fields.chamberOrg,
      percent: fields.percent,
      violationType: fields.violationType,
    },
  };
  return httpClient.post("sampleInspection/createSample", payload, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getSampleCaseDetails = (
  caseId: string,
): Promise<AxiosResponse<SampleCompanyCaseDetailsView>> =>
  httpClient.get(
    `sampleInspection/sampleCaseDetails?sampleCompanyCaseId=${caseId}`,
  );

export const updateUserComments = ({
  caseId,
  chamber_notes,
}: {
  caseId: string;
  chamber_notes: string;
}) => {
  const payload = {
    notes: chamber_notes,
    sampleCompanyCaseId: caseId,
  };
  return httpClient.put("sampleInspection/addSampleCaseNotes", payload);
};

export const assignCaseToUser = ({
  a06_id,
  message,
  caseId,
}: {
  a06_id: string;
  message: string;
  caseId: string;
}) => {
  const payload = {
    assigneeUser: a06_id,
    message: message,
    sampleCompanyCaseId: caseId,
  };
  return httpClient.put("sampleInspection/assignSampleCase", payload);
};

export const getChamberUsers = (isSystemAdmin: boolean) =>
  httpClient.get(
    `sampleInspection/${isSystemAdmin ? "getChambersForAdmin" : "chamberUsersList"}`,
  );

export const completeSampleCase = ({
  actionType,
  caseId,
}: {
  actionType: string;
  caseId: string;
}) => {
  const payload = {
    completionType: actionType,
    sampleCompanyCaseId: caseId,
  };
  return httpClient.put("sampleInspection/completeSampleCase", payload);
};

export const getSampleInspectionDetailsForEdit = (sampleId: string) =>
  httpClient.get(
    `sampleInspection/sampleDetailsForEdit?sampleInspectionId=${sampleId}`,
  );

export const updateSampleInspection = (fields: {
  sampleId: number;
  companySize: string[];
  companyStatus: number[];
  expiryDate: Date;
  corporateStatus: number[];
  chamberOrg: number[];
  percent: number;
  title: string[];
  violationType: number;
  description: string;
}) => {
  const payload = {
    sampleInspectionId: fields.sampleId,
    title: fields.title,
    description: fields.description,
    expiryDate: format(fields.expiryDate, "yyyy-MM-dd"),
    filters: {
      companySize: fields.companySize,
      companyStatus: fields.companyStatus,
      corporateStatus: fields.corporateStatus,
      chamberOrg: fields.chamberOrg,
      percent: fields.percent,
      violationType: fields.violationType,
    },
  };
  return httpClient.put("sampleInspection/editSample", payload);
};

export const initiateInspection = (sampleInspectionId: string | undefined) => {
  return httpClient.put("sampleInspection/initiateSample", {
    sampleInspectionId,
  });
};

export const finalizeInspection = (sampleInspectionId: string | undefined) => {
  return httpClient.put("sampleInspection/finalizeSample", {
    sampleInspectionId,
  });
};

export const deleteSample = (sampleInspectionId: string | undefined) => {
  return httpClient.delete("sampleInspection/deleteSample", {
    data: { sampleInspectionId },
  });
};

export const exportSampleInspection = (sampleId: string | undefined) =>
  httpClient.get(
    `sampleInspection/exportSample?sampleInspectionId=${sampleId}`,
    {
      responseType: "blob",
    },
  );

export const exportSampleInspectionChamber = (sampleId: string | undefined) =>
  httpClient.get(
    `sampleInspection/exportSampleOrganization?sampleInspectionId=${sampleId}`,
    {
      responseType: "blob",
    },
  );

export const getSamplingInspectionDetails = async (
  inspectionId: string | undefined,
) => {
  const formData = new FormData();
  formData.append("sampleInspectionId", inspectionId ?? "");

  const response = await httpClient.post(
    "/sampleInspection/organizationSampleDetails",
    formData,
  );

  return response.data;
};

export const getSamplingInspectionCompanies = async ({
  inspectionId,
  filters,
  pagination,
  sorting,
}: {
  inspectionId: string | undefined;
  filters: any;
  pagination: MRT_PaginationState;
  sorting: MRT_SortingState;
}) => {
  const queryParams: Record<string, any> = {
    ...filters,
    sampleInspectionId: inspectionId,
    start: pagination.pageIndex * pagination.pageSize,
    length: pagination.pageSize,
    companyId: filters.companyId,
    sortingData: JSON.stringify(sorting),
  };

  const formData = new FormData();
  for (let key in queryParams) {
    if (queryParams[key] !== undefined) {
      formData.append(key, queryParams[key]);
    }
  }

  const response = await httpClient.post(
    "/sampleInspection/organizationSampleDetails",
    formData,
  );
  return response.data;
};

export const getSampleInspectionInitiatorsDetails = async (
  inspectionId: string,
) => {
  const formData = new FormData();
  formData.append("sampleInspectionId", inspectionId);

  const response = await httpClient.post(
    "/sampleInspection/sampleDetails",
    formData,
  );

  return response.data;
};

export const getSupervisorySampleDetails = async (inspectionId: string) => {
  const formData = new FormData();
  formData.append("sampleInspectionId", inspectionId);

  const response = await httpClient.post(
    "supervisoryTeam/getSupervisorySampleDetails",
    formData,
  );

  return response.data;
};

export const getSupervisoryCompanyCases = async ({
  inspectionId,
  filters,
  pagination,
  sorting,
}: {
  inspectionId: string | undefined;
  filters: any;
  pagination: MRT_PaginationState;
  sorting: MRT_SortingState;
}) => {
  const queryParams: Record<string, any> = {
    ...filters,
    sampleInspectionId: inspectionId,
    start: pagination.pageIndex * pagination.pageSize,
    length: pagination.pageSize,
    sortingData: JSON.stringify(sorting),
  };

  const formData = new FormData();
  for (let key in queryParams) {
    if (queryParams[key] !== undefined) {
      formData.append(key, queryParams[key]);
    }
  }

  const response = await httpClient.post(
    "supervisoryTeam/getSupervisorySampleDetails",
    formData,
  );
  return response.data;
};

export const getSampleInspectionInitiatorsCompanies = async ({
  inspectionId,
  filters,
  pagination,
  sorting,
}: {
  inspectionId: string | undefined;
  filters: any;
  pagination: MRT_PaginationState;
  sorting: MRT_SortingState;
}) => {
  const queryParams: Record<string, any> = {
    ...filters,
    sampleInspectionId: inspectionId,
    start: pagination.pageIndex * pagination.pageSize,
    length: pagination.pageSize,
    companyId: filters.companyId,
    sortingData: JSON.stringify(sorting),
  };

  const formData = new FormData();
  for (let key in queryParams) {
    if (queryParams[key] !== undefined) {
      formData.append(key, queryParams[key]);
    }
  }

  const response = await httpClient.post(
    "/sampleInspection/sampleDetails",
    formData,
  );
  return response.data;
};
